import type { LucideIcon } from 'lucide-react';

import { Button } from '~/components/ui/button';
import { cn } from '~/lib/utils';

export function ChannelPill({
  active = false,
  className,
  disabled = false,
  icon: Icon,
  label,
  onClick,
}: {
  active?: boolean;
  className?: string;
  disabled?: boolean;
  icon: LucideIcon;
  label: string;
  onClick?: () => void;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'h-9 rounded-full border px-3.5 text-sm font-medium',
        active
          ? 'border-border bg-accent text-foreground hover:bg-accent'
          : 'border-border/60 bg-card text-muted-foreground hover:bg-accent hover:text-foreground',
        className,
      )}
    >
      <Icon className="size-4" strokeWidth={2.5} />
      {label}
    </Button>
  );
}
